import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';
const StyledImage = styled('img')({});
const Image = ({ url, status, alt, className, avatar, avatarVariant, customStyle, backgroundColor, fallbackSrc, updatedAt, }) => {
    const [loaded, setLoaded] = useState(false);
    const [errored, setErrored] = useState(false);
    const onError = useCallback((event) => {
        // console.log('image error event', event);
        if (!errored) {
            setErrored(true);
        }
    }, [errored]);
    const onLoad = () => {
        if (!loaded) {
            setLoaded(true);
        }
    };
    // console.log('Image.url: ', url);
    useEffect(() => {
        // if the bucket or bucketKey changes, clear the error status
        setErrored(false);
    }, [url, status, updatedAt]);
    if (url) {
        if (avatar) {
            return (_jsx(Avatar, { src: errored ? fallbackSrc : url, variant: avatarVariant, alt: alt, sx: {
                    backgroundColor: loaded ? 'inherit' : backgroundColor,
                    ...customStyle,
                } }));
        }
        return (_jsx(StyledImage, { src: errored ? fallbackSrc : url, alt: alt, onError: onError, className: className, onLoad: onLoad, sx: {
                backgroundColor: loaded ? 'inherit' : backgroundColor,
                ...customStyle,
            } }));
    }
    return null;
};
Image.defaultProps = {
    className: '',
    avatar: false,
    customStyle: {},
    avatarVariant: 'circular',
    backgroundColor: '#444444',
    fallbackSrc: undefined,
    updatedAt: undefined,
};
export default observer(Image);
//# sourceMappingURL=Image.js.map